import React from 'react';
import Icon from 'react-fa';


class DeletedNotice extends React.Component {
	
	render() 
	{
	  if(!this.props.show)
		return null;
		
	  return(
	  <div className="DeleteNotice">
		<h4>
		  La solicitud de Borrado de Tarjeta aún no fué confirmada por Link.
		  <Icon name="trash" size="lg" className="DeleteIcon" />
		</h4>
		<p>Aca iría el texto de borrado</p>
	  </div>
	  );	
	
	}
	
}

/*
const DeletedNotice = ({show}) => {
	
  if(!show)
    return null;
	
  return(
  <div className="DeleteNotice">
    <h4>
      La solicitud de Borrado de Tarjeta aún no fué confirmada por Link.
      <Icon name="trash" size="lg" className="DeleteIcon" />
    </h4>
    <p>Aca iría el texto de borrado</p>
  </div>
  );

}*/


export default DeletedNotice;
